import * as type from './type';

export const getCharacterRequest = (payload) => {
  return {
    type: type.GET_CHARACTER_REQUEST,
    payload,
  };
};

export const pushDataVideoStepOne = (payload) => {
  return {
    type: type.PUSH_DATA_VIDEO_STEP_ONE,
    payload,
  };
};

export const pushDataVideoStepTwo = (payload) => {
  return {
    type: type.PUSH_DATA_VIDEO_STEP_TWO,
    payload,
  };
};

export const pushDataVideoStepThree = (payload) => {
  return {
    type: type.PUSH_DATA_VIDEO_STEP_THREE,
    payload,
  };
};

export const pushDataVideoStepFour = (payload) => {
  return {
    type: type.PUSH_DATA_VIDEO_STEP_FOUR,
    payload,
  };
};

export const videoPaymentSaveRequest = (payload) => {
  return {
    type: type.VIDEO_PAYMENT_SAVE_REQUEST,
    payload,
  };
}

export const videoPaymentSaveSuccess = (payload) => {
  return {
    type: type.VIDEO_PAYMENT_SAVE_SUCCESS,
    payload,
  };
}

export const videoPaymentSaveFailed = (payload) => {
  return {
    type: type.VIDEO_PAYMENT_SAVE_FAILED,
    payload,
  };
}


export const getVideoDetailRequest = (payload) => {
  return {
    type: type.GET_VIDEO_DETAIL_REQUEST,
    payload,
  };
};

export const getVideoDetailSuccess = (payload) => {
  return {
    type: type.GET_VIDEO_DETAIL_SUCCESS,
    payload,
  };
};

export const getVideoDetailFailed = (payload) => {
  return {
    type: type.GET_VIDEO_DETAIL_FAILED,
    payload,
  };
};

export const getVideoContentTemplateRequest = (params) => {
  // const params = payload
  return {
    type: type.GET_VIDEO_CONTENT_TEMPLATE_REQUEST,
    params,
  };
};

export const getVideoContentTemplateSuccess = (payload) => {
  return {
    type: type.GET_VIDEO_CONTENT_TEMPLATE_SUCCESS,
    payload,
  };
};

export const getVideoContentTemplateFailed = (payload) => {
  return {
    type: type.GET_VIDEO_CONTENT_TEMPLATE_FAILED,
    payload,
  };
};

export const videoPaymentClearState = (params) => {
  // const params = payload
  return {
    type: type.VIDEO_PAYMENT_CLEAR_STATE,
    params,
  };
};

export const updateExplainVideoPopupRequest = (payload) => {
  console.log(payload, 'updateExplainVideoPopupRequest');
  return {
    type: type.UPDATE_EXPLAIN_VIDEO_POPUP_REQUEST,
    payload,
  };
}

export const updateExplainVideoPopupSuccess = (payload) => {
  return {
    type: type.UPDATE_EXPLAIN_VIDEO_POPUP_SUCCESS,
    payload,
  };
}


export const updateVideoRequest = (params) => {
  return {
    type: type.UPDATE_VIDEO_REQUEST,
    params,
  };
};

export const updateVideoSuccess = (payload) => {
  return {
    type: type.UPDATE_VIDEO_SUCCESS,
    payload,
  };
};

export const updateVideoFailed = (payload) => {
  return {
    type: type.UPDATE_VIDEO_FAILED,
    payload,
  };
}

export const getVideoEmojiRequest = (params) => {
  return {
    type: type.GET_VIDEO_EMOJI_REQUEST,
    params,
  };
}

export const getVideoEmojiSuccess = (payload) => {
  return {
    type: type.GET_VIDEO_EMOJI_SUCCESS,
    payload,
  };
}

export const getVideoEmojiFailed = (payload) => {
  return {
    type: type.GET_VIDEO_EMOJI_FAILED,
    payload,
  };
}

export const deleteVideoRequest = (payload) => {
  return {
    type: type.DELETE_VIDEO_REQUEST,
    payload,
  }
}

export const deleteVideoSuccess = (payload) => {
  return {
    type: type.DELETE_VIDEO_SUCCESS
  }
}

export const deleteVideoFailed = (payload) => {
  return {
    type: type.DELETE_VIDEO_FAILED
  }
}

export const useCouponFromGiftBoxPage = (payload) => {
  return {
    type: type.USE_COUPON_FROM_GIFBOX_PAGE,
    payload
  }
}

export const getRestrictedKeywordRequest = (params) => {
  // const params = payload
  return {
    type: type.GET_RESTRICTED_KEYWORD_REQUEST,
    params,
  };
};

export const getRestrictedKeywordSuccess = (payload) => {
  return {
    type: type.GET_RESTRICTED_KEYWORD_SUCCESS,
    payload,
  };
};

export const getRestrictedKeywordFailed = (payload) => {
  return {
    type: type.GET_RESTRICTED_KEYWORD_FAILED,
    payload,
  };
};

export const getTimeVideoRenderRequest = (params) => {
  return {
    type: type.GET_TIME_VIDEO_RENDER_REQUEST,
    params,
  };
}

export const getTimeVideoRenderSuccess = (payload) => {
  return {
    type: type.GET_TIME_VIDEO_RENDER_SUCCESS,
    payload,
  };
}

export const getTimeVideoRenderFaild = (payload) => {
  return {
    type: type.GET_TIME_VIDEO_RENDER_FAILED,
    payload,
  };
}